/* eslint-disable no-nested-ternary */
import React from 'react';
import { Route } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Logs from './Logs/Logs';
import DetailPage from './Logs/detail/detailPage';
import ReApplyApplication from './initiateForm/ReApplyApplication';
import Violations from './Violations/Violations';
import ViolationDetail from './Violations/Detail';
import MyApplications from './MyApplications/MyApplications';
import StartApplication from './MyApplications/StartApplication';
import InitiateForm from './MyApplications/InitiateForm';
import InitiateAdpForm from './initiateForm/InitiateAdpForm';
import RenewalAdpForm from './initiateForm/RenewalAdpForm';

const AdpLayout = ({ match }) => (
    <>
      <Route exact path={`${match.url}/logs`} component={Logs} />
      <Route
        exact
        path={`${match.url}/initiate/application`}
        component={InitiateAdpForm}
      />
      <Route exact path={`${match.url}/detail/:id`} component={DetailPage} />
      <Route
        exact
        path={`${match.url}/detail/:id/renewal`}
        component={RenewalAdpForm}
      />
      <Route
        exact
        path={`${match.url}/detail/:id/reapply`}
        component={ReApplyApplication}
      />
      <Route exact path={`${match.url}/violations`} component={Violations} />
      <Route
        exact
        path={`${match.url}/violations/detail/:id`}
        component={ViolationDetail}
      />

      <Route
        exact
        path={`${match.url}/myapplications`}
        component={MyApplications}
      />
      <Route
        exact
        path={`${match.url}/myapplications/initiate`}
        component={InitiateForm}
      />
      <Route
        exact
        path={`${match.url}/myapplications/start/:id`}
        component={StartApplication}
      />
      <Route
        exact
        path={`${match.url}/draft/application/:id`}
        component={InitiateAdpForm}
      />
    </>
  );

export default injectIntl(AdpLayout);
